
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export const useExtensionContentTracking = () => {
  const { user } = useAuth();

  const trackExtensionContentSaved = async (contentId: string, metadata?: any) => {
    if (!user) {
      console.log('[Extension Analytics] No user found, skipping tracking');
      return;
    }

    try {
      console.log('[Extension Analytics] Tracking extension content_saved event for:', contentId);
      
      const eventData = {
        content_id: contentId,
        source_method: 'extension',
        extension_version: metadata?.extensionVersion || 'unknown',
        page_url: metadata?.pageUrl || window.location.href,
        has_title: Boolean(metadata?.title?.trim()),
        has_description: Boolean(metadata?.description?.trim())
      };

      console.log('[Extension Analytics] Event data prepared:', eventData);

      const insertData = {
        event_type: 'content_saved_extension',
        event_category: 'content_saving',
        event_data: eventData,
        user_id: user.id,
        session_id: null,
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      };

      const { data, error } = await supabase
        .from('user_activity_events')
        .insert(insertData)
        .select();

      if (error) {
        console.error('[Extension Analytics] Error tracking extension content_saved:', error);
      } else {
        console.log('[Extension Analytics] Successfully tracked extension content_saved event');
      }
    } catch (error) {
      console.error('[Extension Analytics] Failed to track extension content_saved event:', error);
    }
  };

  return {
    trackExtensionContentSaved
  };
};
